
import { OnInit, Component, Input, ViewChildren, QueryList, ViewChild, ElementRef, HostListener } from '@angular/core';
import { IStoreMenuCategory, IStoreMenu, IStoreMenuCategoryItem, StoreService } from '../../services/store.service';
import { MenuService } from '../../services/menu.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { finalize } from 'rxjs/operators';
//import * as moment from 'moment';
import moment from 'moment';
import { ItemBrandServiceService } from '../../services/item-brand-service.service';
import { MENU_CATEGORY_THEME, SettingService } from 'src/app/shared/services/setting.service';
import { Storage } from '@ionic/storage';
import { ItemService } from '../../services/item.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IOrder } from '../../services/order.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

interface selectedSub{
  subCategory: string;
  name: string;
  id: string;
  itemId: string | number
}
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
  export class MenuComponent  implements OnInit {

    @Input() storeName: string;
    @Input() menu: IStoreMenu;
    @Input() navOpen: boolean;
    @Input() order: IOrder;
    @Input() cart: number;
    @Input() location: string;
    @Input() orderType: string;
    categoryUseLightTheme: boolean = false;
    Round = window.Math;
    spanClick: boolean;
    selectedSub: selectedSub[] = [];
    isStoreRetail: boolean=false;

    clicked: boolean=false;
    constructor(
      public menuService: MenuService,
      public itemBrandService: ItemBrandServiceService,
      private storeService: StoreService,
      public itemService: ItemService,
      private imageService: ImageService,
      public settingService: SettingService,
      private route: ActivatedRoute,
      private storage: Storage,
      private router: Router,
      public translationService: TranslationService
      ) { }

    
    ngOnInit(): void {
      const itemId = this.route.snapshot.paramMap.get('itemId');
      if(!itemId)
      {
        this.menuService.sortedMenu.length = 0; 
      }
      let count = 0;
      this.menuService.isStoreRetail = false;
      this.settingService.disablePanel = false;
     
      if (this.settingService.configuration.menuCategoryTheme) {
      if (this.settingService.configuration.menuCategoryTheme == MENU_CATEGORY_THEME.LIGHT) {
          this.categoryUseLightTheme = true; 
        }
      }
      //Below logic is to first see ether merchant selling retail or not
      this.settingService.retailItems = this.settingService.configuration.retailItems;
      if(this.settingService.retailItems)
      {
        //if yes then either the store have it or not
        this.menuService.menu.storeMenuCategories.map(category => {
          category.storeMenuCategoryItems.map(item => {
            if(item.item.isRetailItem)
            {
              count++;
            }
          })
        })
      }
      if(count>0)
      {
        this.menuService.isStoreRetail = true;
      }
  }
  
 
    ngOnDestroy()
    {
      this.settingService.disablePanel = true;
     
    }
    ionViewDidLeave()
    {
      this.settingService.disablePanel = true;
    }


    verifyTimings(itemAvailability)
    {
      let startHours=itemAvailability.startHours.includes('am') ? itemAvailability.startHours.replace("am"," AM") : (itemAvailability.startHours.includes('pm') ? itemAvailability.startHours.replace("pm"," PM") : false);
      let endHours=itemAvailability.endHours.includes('pm')  ? itemAvailability.endHours.replace("pm"," PM") : (itemAvailability.endHours.includes('am') ? itemAvailability.endHours.replace("am"," AM") : false);
      startHours ? moment(startHours, ["h:mm A"]).tz(this.menuService.store.timeZoneInfos.timeZoneId) : false;
      endHours ? moment(endHours, ["h:mm A"]).tz(this.menuService.store.timeZoneInfos.timeZoneId): false;
      if(startHours && endHours)
      {
        if(moment(startHours, ["h:mm A"]).isBefore(moment().tz(this.menuService.store.timeZoneInfos.timeZoneId)) && !moment(endHours, ["h:mm A"]).isBefore(moment().tz(this.menuService.store.timeZoneInfos.timeZoneId)))
        {
          return false;
        }
          else {
            return true;
          }
      }
      return false;
    }

    /*
    getUniqueValues(arr)
    {
      let arrId=[];
      let result=[];
      for(let i=0;i<arr.length;i++)
      {
        for(let j=0;j<arr.length;j++)
        {
            if(!arrId.includes(arr[i].id))
            {
              arrId.push(arr[i].id);
              result.push(arr[i]);
            }
          }
        }
      return result;
    }
    */

    check(item)
    {
      let date=new Date();
      if(item.itemAvailableHour)
      {

        if(item.itemAvailableHour.length>0)
        {

          for(let i=0;i<item.itemAvailableHour.length;i++)
          {
            
            if(date.getDay()==item.itemAvailableHour[i].day)
            {
              let verifyAvailability=this.verifyTimings(item.itemAvailableHour[i])
              if(verifyAvailability)
              {
                return true;
              }
              return false;
             }
          }
          return true;
        }
      }
      if(item.item)
      {
        if(item.item.itemAvailableHour)
        {
          if(item.item.itemAvailableHour.length>0)
          {
            for(let i=0;i<item.item.itemAvailableHour.length;i++)
            {
              
              if(date.getDay()==item.item.itemAvailableHour[i].day) 
              {
                let verifyAvailability=this.verifyTimings(item.item.itemAvailableHour[i])

                if(verifyAvailability)
                {
                  return true;
                }
                return false;
              }
            }
            return true;
          }
        }
      }
    }
    showPrice(item: IStoreMenuCategoryItem) {
      let show = true;
      for (let optionCategory of item.item.itemOptionCategories) {
        if (optionCategory.overrideDefaultPrice) {
          show = false;
        }
      }
  
      return show;
    }

    /*
    fetchMenuImage(menuCategory: IStoreMenuCategory) {
      if (menuCategory.imageDisplayName != null && menuCategory.imageShortName != "" && menuCategory._image == null) {
        this.storeService.getItemImage(menuCategory.imageShortName).subscribe(data => {
          this.imageService.createImageFromBlob(data)
          .pipe(finalize(() => {
             
          }))
          .subscribe((buffer) => {
              menuCategory._image = "url(" + buffer + ")";
          });       
        }, error => {
        });
      }
    }
    */
    
    InCart(item){

      var numofitem = 0;
      //console.log(item);
      //console.log(this.menuService.order.orderItems);
    
      var cartitems = this.menuService.order.orderItems;
    
      for(var i = 0; i < cartitems.length; i++){
        if(item.itemId == cartitems[i].itemId) {
          numofitem++;
        }
      }
    
      return numofitem;
    }

  }

  